import React from 'react';
import PropTypes from 'prop-types';
import {Formik} from 'formik';
import Step18View from './Step18-view';
import {checkRequiredValues} from "../../utils/forms/checkRequiredValues";
import {loadOptionsByDDType} from "../../actions/loadOptionsByDDType";
import {ddTypes} from "../../constants/dropdownTypes";
import {checkNextStepAndGo} from '../../utils/checkNextStepAndGo';
import {
  convertISOStringToDateWithTimezoneOffset,
  convertDateWithTimezoneOffsetToEpoch
} from '../../utils/forms/normalizeTime';
import {useIntl} from "react-intl";
import {trackEvent} from "../../utils/trackEvent";

const Step18 = ({submitStep, language, regType, payload}) => {
  const {
    freelanceStartDate,
    monthlyAverageIncome,
    weeklyAverageWorkHours,
    ...restPayload
  } = payload;
  const initialValues = {
    EditOrClose: false,
    freelanceStartDate: (freelanceStartDate) ? convertISOStringToDateWithTimezoneOffset(freelanceStartDate) : null,
    monthlyAverageIncome: monthlyAverageIncome || '',
    weeklyAverageWorkHours: weeklyAverageWorkHours ? {value: weeklyAverageWorkHours} : '',
    willFrom: null,
    willHours: '',
    willIncome: '',
    closeDate: null,
    ...restPayload
  };

  const validate = values => {
    const {
      EditOrClose,
      willFrom,
      willHours,
      willIncome,
      closeDate,
    } = values;
    let errors = {};

    errors = checkRequiredValues({EditOrClose}, errors);

    if (EditOrClose === 'edit') {
      errors = checkRequiredValues({
        willFrom,
        willHours,
        willIncome,
      }, errors);
    } else {
      errors = checkRequiredValues({closeDate}, errors);
    }

    return errors;
  };

  const {formatMessage} = useIntl();

  const handleSubmit = values => {
    const {
      EditOrClose,
      willFrom: freelanceStartDate,
      willHours: {value: weeklyAverageWorkHours},
      willIncome: monthlyAverageIncome,
      closeDate
    } = values;
    const date = (EditOrClose === 'edit')
      ? {
        freelanceStartDate: convertDateWithTimezoneOffsetToEpoch(freelanceStartDate),
        weeklyAverageWorkHours,
        monthlyAverageIncome,
      }
      : {closeDate: convertDateWithTimezoneOffsetToEpoch(closeDate)};

    submitStep({
      step: 18,
      data: {...date, EditOrClose, regType},
    })
      .then(checkNextStepAndGo)
      .then(() => trackEvent('signup_step',
          {
            step_number: 18,
            step_name_en: 'Insurance',
            step_name_he: formatMessage({id: 'step18.page.title', defaultMessage: ''}),
            regType
          }
        )
      )
      .catch(err => console.log({err}));
  };

  const loadMonthlyIncomeOptions = (inputValue, callback) => {
    loadOptionsByDDType({callback, language, ddType: ddTypes.weekAverageHoursItems})
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validate={validate}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnBlur={false}
    >
      {({values, isValid, submitCount}) => (
        <Step18View
          loadOptions={loadMonthlyIncomeOptions}
          values={values}
          isValid={isValid || submitCount === 0}
        />
      )}
    </Formik>
  )
};

Step18.propTypes = {
  regType: PropTypes.string,
  payload: PropTypes.object,
  submitStep: PropTypes.func
};

export default Step18;
